module.exports = __webpack_public_path__ + "static/img/29.a4dafae1.png";